// import { useAppDispatch, useAppSelector } from '../../../../ReduxToolkit/Hooks';
// import { Filter } from 'react-feather';
import { Link } from 'react-router-dom';
// import { setFilterToggle } from '../../../../ReduxToolkit/Reducers/ProductSlice';

const LockerListFilterHeader = () => {
    // const { filterToggle } = useAppSelector((state) => state.product);
    // const dispatch = useAppDispatch();

    return (
      <div>
        {/* <div className="light-box" onClick={() => dispatch(setFilterToggle())}>
          <Link to={Href}>
            <Filter className={`filter-icon ${filterToggle ? "hide" : "show"}`} />
            <i className={`icon-close filter-close ${filterToggle ? "show" : "hide"}`} />
          </Link>
        </div> */}
        <Link className="btn btn-primary" to={`${process.env.PUBLIC_URL}/locker/create_new`}>
          <i className="fa fa-plus" />
          Create New Locker
        </Link>
      </div>
    );
}

export default LockerListFilterHeader